export function fetchDataApi(uri = "", method = "GET", data = {}) {
    return new Promise((resolve, reject) => {
        if (method === "GET") {
            fetch(uri)
                .then((res) => {
                    return res.json();
                })
                .then((result) => {
                    resolve(result);
                })
                .catch((err) => {
                    reject(err);
                })
        } else if (method === 'POST') {
            const fetchData = {
                method:  "POST",
                body:    JSON.stringify(data),
                headers: new Headers(),
            }
            fetch(uri, fetchData)
                .then((res) => {
                    return res.json();
                })
                .then((result) => {
                    resolve(result);
                })
                .catch((err) => {
                    reject(err);
                })
        }
    });
}

export function cleaningDataBeforeSend(data, dataForClearing) {
    const cleanedData = {...data};
    for(const prop in cleanedData) {
        if (dataForClearing.some((el) => {return el === data[prop]})) {
            delete data[prop];
        }
    }
    return cleanedData;
}





// WEBPACK FOOTER //
// ./src/api/fetchData.js